import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'adc-dropdown',
  templateUrl: './adc-dropdown.component.html',
  styleUrls: ['./adc-dropdown.component.scss'],
  standalone: false
})
export class AdcDropdownComponent implements OnInit {
  @Input('data') data: any;
  @Input('type') type: string = 'basic';
  @Output() selectedVal = new EventEmitter();
  // selectedVal: string = 'Select';
  showDropdown: boolean = false;
  showDropdown_: boolean = false;
  noOfOptions: any;
  showOption: any;
  selectedOption: any = [];
  showSelected: any;

  ngOnInit() {
    this.showOption = this.data.list;
  }

  dropdown(event: any) {
    // this.selectedVal = opt;
    // this.showDropdown = false;
    const dropdownContent = document.querySelector('.adc-dropdown-option-menu');

    if (dropdownContent && !dropdownContent.contains(event.target as Node)) {
      this.showDropdown_ = false;
    } else {
      this.showDropdown_ = !this.showDropdown_;
    }
  }

  dropdown1() {
    this.showDropdown = !this.showDropdown;
  }

  dropdown2(event: any) {
    // this.showDropdown = !this.showDropdown;
    const dropdownContent = document.querySelector('.adc-dropdown-option-menu');

    if (dropdownContent && !dropdownContent.contains(event.target as Node)) {
      this.showDropdown = false;
    } else {
      this.showDropdown = !this.showDropdown;
    }
  }

  openDrop() {
    this.showDropdown = !this.showDropdown;
  }

  search(event: any) {
    const searchText = event.target.value.toLowerCase();
    // if(searchText == '') {
    //   this.showOption = this.option;
    // }
    this.showOption = this.data.list.filter((o: any) =>
      o.label.toLowerCase().includes(searchText)
    );
  }

  multiSelect(option: any) {
    // if(!this.multiSelected.includes(option)) {
    //   this.multiSelected.push(option);
    // } else {
    //   this.multiSelected = this.multiSelected.filter((i: any) => i !== option );
    //   this.option.isSelected = false;
    // }

    option.isSelected = !option.isSelected;
    
    this.noOfOptions = this.data.list.filter((i: any) => i.isSelected == true);
    this.selectedOption = [];
    for(let i of this.noOfOptions) {
      this.selectedOption.push(i.label);
    }
    this.selectedVal.emit(this.selectedOption);
    // this.DropdownDisplay = this.multiSelected.join(", ")
  }

  selected(option: any) {
    this.selectedVal.emit(option);
    this.showSelected = option;
    this.showDropdown = false;
  }

  onSelected(event: any) {
    this.selectedVal.emit(event.target.value);
  }
}
